import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GaleriePage from "../pages/galerie/page";
import HighlightsPage from "../pages/highlights/page";
import LagePage from "../pages/lage/page";
import KontaktPage from "../pages/kontakt/page";
import TerminPage from "../pages/termin/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/galerie", element: <GaleriePage /> },
  { path: "/highlights", element: <HighlightsPage /> },
  { path: "/lage", element: <LagePage /> },
  { path: "/kontakt", element: <KontaktPage /> },
  { path: "/termin", element: <TerminPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
